<template>
  <div class="form-container">
    <div class="data-container">

      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
        <h3>订单客户信息</h3>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerId">
              <el-select
                  v-model="addForm.customerId"
                  :placeholder="this.customerName || '请输入客户名称'"
                  filterable
                  remote
                  :disabled="true"
                  reserve-keyword
                  :remote-method="fetchCustomerList"
                  :loading="customerLoding"
                  style="min-width: 150px; width: 200px;max-width:350px; resize: horizontal; overflow: auto;"
                  @change="handleCustomerChange"
              >
                <el-option
                    v-for="item in customerOptions"
                    :key="item.id"
                    :label="item.customerName"
                    :value="item.id"
                >
                  <!-- 自定义下拉列表显示内容：客户名称和手机号 -->
                  <template v-slot:default>
                    <div style="display: flex; justify-content: space-between;">
                      <span>{{ item.customerName }}</span>
                      <span style="color: #888;">{{ item.phoneNumber }}</span>
                    </div>
                  </template>
                </el-option>

              </el-select>
              <el-tooltip content="客户信息请谨慎修改">
                <i class="el-icon-info"></i>
              </el-tooltip>
<!--              <el-button type="primary"  @click="recall">撤回修改</el-button>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="联系电话"  >
              <el-input v-model="this.phoneNumber"  style="width: 200px" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户来源"  >
              <el-input v-model="this.customerSource"  style="width: 200px" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="客户级别" >
              <el-input v-model="this.customerLabel"  style="width: 200px" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户销售渠道"  >
              <el-input v-model="this.customerType"  style="width: 200px" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <h3>订单数据</h3>
        <el-form-item label="订单编号" prop="orderSn">
          <span>{{ this.addForm.orderSn }}</span>
        </el-form-item>
        <el-form-item label="发货仓库" prop="stash">
          <el-input v-model="addForm.stash" style="width: 500px" placeholder="请输入发货仓">
          </el-input>
        </el-form-item>
        <div style="display: flex; align-items: center;">
          <h3>产品信息</h3>
          <el-button @click="showProductDialog" type="primary" icon="el-icon-s-goods" plain style="margin-left: 20px">选择产品</el-button>
        </div>
        <el-table :data="addForm.productDetail" v-loading="listLoading" style="width: 100%" border>
          <el-table-column prop="productName" label="产品名称" width="100" :align="'center'"></el-table-column>
          <el-table-column prop="picture" label="产品图片" width="140" :align="'center'">
            <template slot-scope="scope">
              <img :src="scope.row.picture" :preview-src-list="[scope.row.picture]" alt="Product Image"
                   style="width: 100px; height: 100px;">
            </template>
          </el-table-column>
          <el-table-column prop="price" label="产品价格" width="100" :align="'center'"></el-table-column>
          <el-table-column prop="costPrice" label="成本价" width="100" :align="'center'"></el-table-column>
          <el-table-column label="采购数量(箱)"  :align="'center'">
            <template slot-scope="scope">
              <el-input-number
                  v-model="scope.row.purchaseQuantity"
                  size="mini"
                  :min="0"
                  :controls="false"
                  style="width: 100px"
                  :value="scope.row.purchaseQuantity || 0"
              @change="calculateOrderAmount(scope.row)"
              >
              </el-input-number>
            </template>
          </el-table-column>

          <el-table-column prop="salePrice" label="成交价(元)"  :align="'center'">
            <template slot-scope="scope">
              <el-input-number
                  v-model="scope.row.salePrice"
                  size="mini"
                  :min="0"
                  :controls="false"
                  style="width: 100px"
                  :value="scope.row.salePrice || 0.00"
              @change="calculateOrderAmount(scope.row)"
              >
              </el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="订单金额(元)"  :align="'center'">
            <template slot-scope="scope">
              {{ calculateOrderAmount(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" :align="'center'">
            <template scope="scope">
              <el-button type="text" size="mini" @click="cancelshowData(scope.row.id, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; text-align: left; font-weight: bold;">
          订单总金额: {{ totalOrderAmount.toFixed(2) }} 元
        </div>
        <div style="margin-top: 20px; text-align: left; font-weight: bold;">
          总采购数量: {{ purchaseNum }} 箱
        </div>
        <h3>物流信息</h3>
        <el-form-item label="快递公司" prop="logisticsCompanies">
          <el-input v-model="addForm.logisticsCompanies" style="width: 500px" placeholder="请输入快递公司">
          </el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="shippingAddress">
          <div style="width: 500px;">
            <el-row type="flex" align="top">
              <el-col :span="20">
                <el-input
                    v-model="addForm.shippingAddress"
                    type="textarea"
                    :rows="2"
                    auto-complete="off"
                    style="width: 100%;"
                ></el-input>
              </el-col>
              <el-col :span="4" style="padding-left: 10px; display: flex; align-items: flex-start;">
                <addressSelector
                    :customer-id="addForm.customerId"
                    v-model="addForm.shippingAddress"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="快递备注" prop="notes">
          <el-input v-model="addForm.remarks" type="textarea" :rows="3" style="width: 500px"
                    auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="订单备注" prop="notes">
          <el-input v-model="addForm.notes" type="textarea" :rows="3" style="width: 500px"
                    auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="发货方式" prop="logisticsMethods">
          <el-select v-model="addForm.logisticsMethods"
                     filterable allow-create default-first-option clearable placeholder="请选择或手动输入发货方式">
            <el-option
                v-for="item in ShippingMethod"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-tooltip content="选择框不满足时,可以自己手动输入">
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-form-item>


        <h3>收款信息</h3>
        <el-form-item   label="收款方式" prop="payType">
          <el-input v-model="addForm.payType" style="width: 300px" placeholder="请输入收款方式">
          </el-input>
        </el-form-item>
        <el-form-item   label="支付状态" prop="paymentStatus">
          <el-radio v-model="addForm.paymentStatus" label="已支付" border>已支付</el-radio>
          <el-radio v-model="addForm.paymentStatus" label="欠款" border>欠款</el-radio>
        </el-form-item>
        <el-form-item label="收款凭证" prop="receipt">
          <!-- 显示已上传的图片 -->
          <el-row :gutter="20" style="margin-top: 20px;">
            <el-col v-for="(url, index) in receiptList" :key="index" :span="6">
              <el-image
                  style="width: 100%; height: 100px"
                  :src="url"
                  :preview-src-list="receiptList"
                  :z-index="2000">
              </el-image>
            </el-col>
          </el-row>
          <el-upload
              class="upload-demo"
              name="file"
              :action="this.$uploadURL"
              :on-remove="handleFileRemove"
              :on-success="handleFileUpload"
              :on-exceed="handleFileExceed"
              :multiple="true"
              :limit="5"
              :file-list="fileList"
              accept=".jpg,.png,.gif"
              list-type="picture">
            <!--              :headers="{ Authorization: 'Bearer ' + localStorage.getItem('token') }">-->
            <el-button size="small" type="primary">点击上传</el-button>
            <!--            <div slot="tip" class="el-upload__tip">只能上传指定类型图片文件，且不超过500kb</div>-->
          </el-upload>
        </el-form-item>

        <el-form-item label="订单审核人" prop="orderReviewerId">
          <el-select v-model="addForm.orderReviewerId" placeholder="请选择审核人!">
            <el-option v-for="item in this.examines"
                       :key="item.id" :label="item.adminName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">创建订单</el-button>
      </div>
    </div>

    <ProductSelect :visible.sync="productFormVisible"  :selected-products-from-parent="addForm.productDetail"  @upload-products="handleUploadProducts"></ProductSelect>

    <LoadingPage
        :visible="addLoading"
        :isCompleted="addCompleted"
        :text="loadingText"
        :doneText="loadingDoneText"
        @animation-end="onLoadingAnimationEnd"
    />

  </div>

</template>
<script>
import util from '../../common/js/util'

export default {
  name:'orderReEdit',
  data() {
    return {
      addCompleted: false,
      loadingText: '订单正在创建中，请稍后...',
      loadingDoneText: '订单创建成功！',
      OldOrderSn:'',
      //客户搜索
      customerOptions:[],
      customerLoding:false,//客户模糊搜索动画
      customerType:'',
      customerSource:'',
      customerLabel:'',
      phoneNumber:'',
      customerInfoCopy:{},//复制原客户信息
      totalOrderAmount: 0.00, // 用于存储订单总金额
      purchaseNum:0,
      //传递过来的客户id
      reviewRemarks:'',//驳回理由
      customerId:'',
      customerName:'',
      examines:[],//审核人列表

      orderDetails: [], // 订单详情数组，包含产品ID、金额和数量
      sels: '',
      fileList: [],
      receiptList: [], // 用于存储拆分后的图片链接数组
      productFormVisible: false,//产品页面
      listLoading: false,
      productLists: [],
      productList: [],
      purchaseQuantity: '',
      selectedProductSet: new Set(),
      addLoading: false,
      addFormRules: {
        customerId:[{
          required: true, message: '请输入客户名称', trigger: 'blur'
        }],
        logisticsCompanies:[{
          required: true, message: '请输入快递公司', trigger: 'blur'
        }],
        logisticsMethods:[{
          required: true, message: '请输入发货方式', trigger: 'blur'
        }],
        orderReviewerId:[{
          required: true, message: '请输入订单审核人', trigger: 'blur'
        }],
        payType:[{
          required: true, message: '请输入收款方式', trigger: 'blur'
        }],
        shippingAddress:[{
          required: true, message: '请输入收货地址', trigger: 'blur'
        }],
      },
      showLargeImage: false,
      copyOrderSn:'',
      orderDetail:{},

      oldcustomerId:'',
      //新增界面数据
      addForm: {
        customerDetail:{
        },
        productDetail:[],
        customerId: '',

        orderSn: '',
        stash: '',
        logisticsCompanies: '',
        notes: '',
        logisticsMethods: '',
        productId: '',
        payType: '',
        receipt: '',
        loginId: '',
        productNumber: '',
        orderAmount: '',
        orderProducids:[],
        orderDetail: {
          id: '',
          name: '',
          phone: '',
          province: '',
          city: '',
          district: '',
          detailAddress: '',
        },
        orderReviewerId:'',
        updateState:'',//客户信息是否更改
        oldcustomerId:'',//原客户id
      },

      //发货方式的选择
      ShippingMethod: [
        {label:"快递",value:"快递"},{label:"物流",value:"物流"},{label:"自提",value:"自提"},
        {label:"客户自己叫车",value:"客户自己叫车"},{label:"整车拉",value:"整车拉"},{label:"拉货车",value:"拉货车"},
      ],

      //订单审核人
      orderReviewer:{
        id:'',
        adminName: '',
      },

      serousList: [],
      total: 0,
      currentPage: 1,
      keyword: "",
      totals: 0,
      pageSize: 5,
    }
  },

  methods: {
    handleUploadProducts(selectedProducts) {
      // ✅ 直接赋值
      this.addForm.productDetail = selectedProducts;

      // ✅ 如果还有其他结构比如 orderDetails 也可以继续构建
      this.orderDetails = selectedProducts.map(product => ({
        id: product.id,
        amount: 0,
        quantity: 0,
        salePrice: 0
      }));

      this.$message.success('产品添加成功');
    },

    generateOrderSn() {
      // 生成订单编号的逻辑，这里使用当前时间的简单示例
      const currentTime = new Date();
      const year = currentTime.getFullYear();
      const month = (currentTime.getMonth() + 1).toString().padStart(2, '0');
      const day = currentTime.getDate().toString().padStart(2, '0');
      const hour = currentTime.getHours().toString().padStart(2, '0');
      const minute = currentTime.getMinutes().toString().padStart(2, '0');
      const second = currentTime.getSeconds().toString().padStart(2, '0');
      return `${year}${month}${day}${hour}${minute}${second}`;
    },
    //查询审核人有哪些
    findExamine(){
      this.$http.get('employee/examine').then(res => {
        this.examines=res.data;
      })
    },
    //客户名字模糊搜索
    fetchCustomerList(query) {
      if (query !== '') {
        this.customerLoding = true;

        // 发起 GET 请求，并将查询关键字传递给后台
        this.$http.get('/customMycustom/getCustomer', { params: { name: query } })
            .then(response => {
              // 假设返回数据格式为 [{ id: '1', name: '客户A', phone: '1234567890' }, ...]
              this.customerOptions = response.data;
            })
            .catch(error => {

            })
            .finally(() => {
              this.customerLoding = false;
            });
      } else {
        // 清空选项
        this.customerOptions = [];
      }
    },
    handleCustomerChange(selectedCustomerId) {
      // 根据选中的 customerId 查找对应的客户信息
      // 用户选择了某个客户
      this.addForm.updateState = "change";
      const selectedCustomer = this.customerOptions.find(
          (item) => item.id === selectedCustomerId
      );

      if (selectedCustomer) {
        // 将客户信息填入表单
        this. customerType = selectedCustomer.customerType || "";
        this.customerLabel = selectedCustomer.customerLabel || "";
        this.customerSource = selectedCustomer.customerSource || "";
        this.phoneNumber = selectedCustomer.phoneNumber || "";
      }},

    //根据订单号查询出订单的所有数据
    //需要查询的数据,订单的基本信息,收件人信息,订单产品信息

    getOrderSnDetail(){
      const orderSn=this.copyOrderSn;
      this.$http.put('orderList/orderDetail/'+orderSn).then((res)=>{
        this.addForm=res.data;
        this.OldOrderSn=this.addForm.orderSn;
        this.addForm.orderSn=this.generateOrderSn()
        // 将 receipt 字符串拆分为数组
        this.receiptList = this.addForm.receipt ? this.addForm.receipt.split(',') : [];
        this.oldcustomerId=this.addForm.customerId;
        this.customerName=this.addForm.customerDetail.customerName;
        this.customerLabel=this.addForm.customerDetail.labelName;
        this.customerSource=this.addForm.customerDetail.sourceName;
        this.customerType=this.addForm.customerDetail.typeName;
        this.phoneNumber=this.addForm.customerDetail.phoneNumber;
        this.reviewRemarks=this.addForm.reviewRemarks;

        if (!this.customerOptions.some(item => item.id === this.addForm.customerId)) {
          this.customerOptions.push({
            id: this.addForm.customerId,
            customerName: this.customerName
          });
        }
      })
    },
    // //撤回修改
    // recall(){
    //   this.addForm.customerId=this.customerInfoCopy.customerId;
    //   this.customerName=this.customerInfoCopy.customerName;
    //   this.customerType=this.customerInfoCopy.customerType;
    //   this.customerLabel=this.customerInfoCopy.customerLabel;
    //   this.customerSource=this.customerInfoCopy.customerSource;
    //   this.phoneNumber=this.customerInfoCopy.phoneNumber;
    //
    // },

    calculateOrderAmount(product) {
      // 找到订单详情中是否已经存在该产品
      const orderDetail = this.orderDetails.find(detail => detail.id === product.id);

      // 确保 salePrice 和 purchaseQuantity 都有值，并处理空值情况
      const salePrice = product.salePrice || 0.00;
      const purchaseQuantity = product.purchaseQuantity || 0;

      // 计算金额并确保格式正确
      let amount = (salePrice * purchaseQuantity).toFixed(2);

      if (orderDetail) {
        // 更新已存在的订单详情
        orderDetail.amount = parseFloat(amount);
        orderDetail.quantity = purchaseQuantity;
        orderDetail.salePrice = salePrice;
      } else {
        // 新增订单详情
        this.orderDetails.push({
          id: product.id,
          amount: parseFloat(amount),
          quantity: purchaseQuantity,
          salePrice: salePrice
        });
      }

      // 统计所有产品的选购数量
      this.purchaseNum = this.orderDetails.reduce((total, detail) => {
        return total + detail.quantity;
      }, 0);

      // 重新计算总金额
      this.totalOrderAmount = this.orderDetails.reduce((total, detail) => {
        return total + detail.amount;
      }, 0);

      return parseFloat(amount);
    },

    showProductDialog: function () {
        this.productFormVisible = true;
    },
    cancelshowData(productId, row) {
      // 在 productList 中找到与当前 productId 相匹配的产品，并删除
      const index = this.addForm.productDetail.findIndex(product => product.id === productId);
      if (index !== -1) {
        this.addForm.productDetail.splice(index, 1);
      }

      // 删除 orderDetails 中具有相同产品 ID 的整个数据对象
      this.orderDetails = this.orderDetails.filter(detail => detail.id !== productId);
      // 重新计算总金额
      // 统计所有产品的选购数量
      this.purchaseNum = this.orderDetails.reduce((total, detail) => {
        return total + detail.quantity;
      }, 0);

      this.totalOrderAmount = this.orderDetails.reduce((total, detail) => {
        return total + detail.amount;
      }, 0);
    },

    //文件删除时的回调
    handleFileRemove(file, fileList) {
      //正式删除
      var fileName = null;
      if (file.response) {  //上传图片的时候点了删除
        fileName = file.response.resultObj;
      } else {  //点击修改回显的图片，点了删除
        fileName = file.url;
      }
      //为了方便参数传递,需要转换路径写法,把/替换为_
      fileName = fileName.replaceAll("/", "_");
      //发送请求
      this.$http.delete("/minio/" + fileName).then(res => {
        if (res.data.success) {
          this.$message.success("删除成功");
          this.fileList = [];
          this.addForm.picture = "";
        } else {
          this.$message.error("删除失败");
        }
      })
    },

    //文件上传成功之后的回调
    handleFileUpload(response) {
      if (response.success) {
        this.addForm.receipt.push(response.resultObj) ;
      }
    },
    //上传超过数量的回调
    handleFileExceed() {
      this.$message.error("不能上传多张图片");
    },

    //6.选项改变时触发
    selsChange: function (sels) {
      this.selectedProductSet = new Set(sels.map(item => item.id));
    },

    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确定要创建新订单吗', '提示', {}).then(() => {
            // 显示 loading 动画
            this.addLoading = true;
            this.addCompleted = false;
            const logininfo = JSON.parse(localStorage.getItem("logininfo"));
            this.addForm.loginId = logininfo.id;

            const orderProductIdList = this.orderDetails.reduce((result, detail) => {
              result.push({
                productId: detail.id,
                orderAmount: detail.amount,
                orderNum: detail.quantity,
                salePrice: detail.salePrice,
              });
              return result;
            }, []);

            this.addForm.orderProducids = orderProductIdList;
            this.addForm.oldOrderSn=this.OldOrderSn;
            let para = Object.assign({}, this.addForm);
            // para.receipt=para.receipt.join(',');
            this.$http.put("/orderList/reOrder", para).then(res => {
              if (res.data.success) {
                // 播放完成动画
                this.addCompleted = true;
                this.$message({
                  message: '订单创建成功，等待审核中!',
                  type: 'success'
                });
                // 动画播放结束后关闭 loading 并跳转
                setTimeout(() => {
                  this.addLoading = false;
                  this.$message({
                    message: '订单创建成功，等待审核中!',
                    type: 'success'
                  });
                  this.$router.push({
                    path: '/MyOrders',
                  });

                  // this.$refs['addForm'].resetFields();
                  // this.orderDetails.resetFields();
                }, 1000); // 这里动画播放时间1秒，根据实际动画时间调整

              } else {
                this.addLoading = false;
                this.$message.warning("系统繁忙，请稍后重试!!!");
              }
            }).catch(() => {
              this.addLoading = false;
            });

          });
        }
      });
    },
    // loading 动画播放完毕后的处理（关闭 + 跳转）
    onLoadingAnimationEnd() {
       this.addLoading = false;
      this.addCompleted = false;

      // 假设跳转页面
      // this.$router.push({ path: "/MyOrders" });
    }

  },
  mounted() {

    this.findExamine();
    const orderSn = this.$route.params.orderSn; // 从路由参数获取订单编号
    if (!orderSn) {
      // 如果订单编号不存在则跳转到我的订单
      this.$router.push({name: '我的订单列表'});
    }else {
      this.copyOrderSn = orderSn;
    }
    this.getOrderSnDetail();
  }
}

</script>
<style>
.form-container {
  margin-top: 50px;
  margin-left: 10px;
  width: 1000px;
  height: 800px;
}
</style>
<style scoped>
.tag-container {
  display: flex;
  align-items: center; /* 让标签垂直居中显示 */
  flex-wrap: wrap;
}

.tag-label {
  background-color: #e6f1fe;
  color: #1d8ce0;
  padding: 4px 8px;
  border-radius: 4px;
  margin-right: 8px; /* 间隔大小可以根据需要调整 */
  margin-bottom: 3px;
  white-space: nowrap; /* 防止文字换行 */
  display: inline-block; /* 让每个标签作为一个块级元素显示 */
}


</style>



// WEBPACK FOOTER //
// orderRecreating.vue?2957568e